import React from "react";
import MasterLayout from "../../masterLayout/MasterLayout";
import Breadcrumb from "../../components/Breadcrumb";
import HelpCenterListLayer from "../../components/HelpCenter/HelpCenterListLayer";

const HelpCenterListPage = () => {
     return (
          <>
               {/* MasterLayout */}
               <MasterLayout>
                    {/* Breadcrumb */}
                    <Breadcrumb title="Help Center List" />

                    {/* TermsConditionLayer */}
                    <HelpCenterListLayer />
               </MasterLayout>
          </>
     );
};

export default HelpCenterListPage;
